if (!customElements.get('shoev-gallery-carousel')) {
  customElements.define('shoev-gallery-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this._controller = new AbortController();
      this._sources = Array.from(this.querySelectorAll('[data-gallery-source]'));
      this._track = this.querySelector('[data-gallery-track]');
      this._lightbox = this.querySelector('[data-gallery-lightbox]');
      this._image = this.querySelector('[data-gallery-lightbox-image]');
      this._current = -1;
      this._lastFocus = null;
      this._savedScroll = 0;
      this._userPaused = false;
      if (!this._lightbox || !this._image || !this._sources.length) return;

      const signal = this._controller.signal;
      this._sources.forEach((source, index) => source.addEventListener('click', () => this.open(index), { signal }));
      this.querySelector('[data-gallery-close]').addEventListener('click', () => this.close(), { signal });
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.move(1), { signal });
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => this.move(-1), { signal });
      this._lightbox.addEventListener('click', (event) => {
        if (event.target === this._lightbox) this.close();
      }, { signal });
      this._lightbox.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
      document.addEventListener('visibilitychange', () => this.syncPauseState(), { signal });

      ['pointerdown', 'wheel', 'touchstart'].forEach((eventName) => {
        this.addEventListener(eventName, () => this.pauseForUser(), { signal, passive: true });
      });
      this.addEventListener('keydown', () => this.pauseForUser(), { signal });
    }

    disconnectedCallback() {
      if (this._controller) this._controller.abort();
      this._initialized = false;
    }

    setPaused(paused) {
      if (this._track) this._track.classList.toggle('is-paused', paused);
    }

    syncPauseState() {
      this.setPaused(this._userPaused || document.hidden);
    }

    pauseForUser() {
      this._userPaused = true;
      this.syncPauseState();
    }

    open(index) {
      this._current = index;
      this._lastFocus = this._sources[index];
      this.showImage();
      this._savedScroll = window.scrollY || window.pageYOffset;
      document.documentElement.classList.add('shoev-gallery-open');
      document.body.style.overflow = 'hidden';
      this._lightbox.hidden = false;
      this._lightbox.classList.add('is-open');
      this._lightbox.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => this.querySelector('[data-gallery-close]').focus({ preventScroll: true }));
    }

    close() {
      if (!this._lightbox.classList.contains('is-open')) return;
      this._lightbox.classList.remove('is-open');
      this._lightbox.setAttribute('aria-hidden', 'true');
      this._lightbox.hidden = true;
      this._image.removeAttribute('src');
      document.documentElement.classList.remove('shoev-gallery-open');
      document.body.style.removeProperty('overflow');
      window.scrollTo(0, this._savedScroll);
      if (this._lastFocus && document.contains(this._lastFocus)) this._lastFocus.focus({ preventScroll: true });
    }

    move(delta) {
      this._current = (this._current + delta + this._sources.length) % this._sources.length;
      this.showImage();
    }

    showImage() {
      const sourceImage = this._sources[this._current].querySelector('img');
      if (!sourceImage) return;
      const src = sourceImage.currentSrc || sourceImage.src;
      this._image.src = src.replace(/width=\d+/, 'width=1600');
      this._image.alt = sourceImage.alt || '';
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(this._lightbox.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
}
